import { render } from "./MAOOtpPage.vue?vue&type=template&id=0c44efb6&scoped=true"
import script from "./MAOOtpPage.vue?vue&type=script&lang=js"
export * from "./MAOOtpPage.vue?vue&type=script&lang=js"

import "./MAOOtpPage.vue?vue&type=style&index=0&id=0c44efb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c44efb6"]])

export default __exports__